import { render } from "./HorseGeneralHistoryTab.vue?vue&type=template&id=47c2cc87"
import script from "./HorseGeneralHistoryTab.vue?vue&type=script&lang=js"
export * from "./HorseGeneralHistoryTab.vue?vue&type=script&lang=js"

import "./HorseGeneralHistoryTab.vue?vue&type=style&index=0&id=47c2cc87&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__